import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/modules/shared.module';
import { ClientsComponent } from './clients.component';
import { ClientsRoutingModule } from './clients-routing.module';
import { ClientsFilterPipe } from './clients-filter.pipe';
import { DeleteDialogComponent } from './delete-dialog/delete-dialog.component';
import { AddDialogComponent} from './add-dialog/add-dialog.component';
import { UpdateDialogComponent } from './update-dialog/update-dialog.component';

@NgModule({
  declarations: [
      ClientsComponent,
      ClientsFilterPipe,
      DeleteDialogComponent,
      AddDialogComponent,
      UpdateDialogComponent
    ],
  imports: [
    CommonModule,
    ClientsRoutingModule,
    SharedModule,
    
  ],
  entryComponents: [
    DeleteDialogComponent,
    AddDialogComponent,
    UpdateDialogComponent
  ],
})
export class ClientsModule { }
